import { NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, forwardRef, HostBinding, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonToggle } from '@angular/material/button-toggle';
import { MatError, MatSuffix } from '@angular/material/form-field';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators,
} from '@angular/forms';

import { MatErrorMessagesDirective } from 'shared/directives';

interface ItemType<T> {
  label: string;
  value: T;
}

@Component({
  selector: 'app-toggle-buttons',
  templateUrl: './toggle-buttons.component.html',
  styles: `
    :host {
      width: 100%;
    }
  `,
  imports: [
    NgForOf,
    TranslateModule,
    MatIcon,
    MatButtonToggle,
    MatSuffix,
    NgIf,
    FormsModule,
    MatError,
    MatErrorMessagesDirective,
  ],
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ToggleButtonsComponent),
      multi: true,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleButtonsComponent),
      multi: true,
    },
  ],
})
export class ToggleButtonsComponent<T> implements Validators, ControlValueAccessor {
  @Input() public items: ItemType<T>[] = [];
  @Input() public value: T | null = null;
  @Output() public valueChange = new EventEmitter<T | null>();
  @Input() @HostBinding('class') public hostClass = '';
  @Input() public hideSingleSelectionIndicator = false;
  public control: AbstractControl<T> | null = null;

  public onToggle(value: T | null): void {
    if (this.value === value) {
      this.value = null;
    } else {
      this.value = value;
    }
    this.onChange(this.value);
    this.valueChange.emit(value);
  }

  public writeValue(value: T | null): void {
    this.value = value;
  }

  public registerOnChange(onChange: (value: T | null) => void): void {
    this.onChange = onChange;
  }

  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  public onChange = (value: T | null): void => {
    //placeholder implementation
    console.log(value);
  };

  public onTouched = (): void => {
    //placeholder implementation
  };

  public validate(control: FormControl): ValidationErrors | null {
    if (!this.control) this.control = control;
    return null;
  }
}
